/**
 * @generated SignedSource<<84041f5ac880af14aaf57d8e803070a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupHeader_issueTableGrouping$data = {
  readonly fieldType: string | null | undefined;
  readonly fieldValue: {
    readonly " $fragmentSpreads": FragmentRefs<"assigneeGroupHeader_issueTableGrouping" | "categoryGroupHeader_issueTableGrouping" | "goalGroupHeader_issueTableGrouping" | "priorityGroupHeader_issueTableGrouping" | "sprintGroupHeader_issueTableGrouping" | "statusGroupHeader_issueTableGrouping" | "storyPointsGroupHeader_issueTableGrouping">;
  } | null | undefined;
  readonly id: string;
  readonly issueCount: number | null | undefined;
  readonly " $fragmentType": "groupHeader_issueTableGrouping";
};
export type groupHeader_issueTableGrouping$key = {
  readonly " $data"?: groupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "groupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "fieldType"
    },
    {
      "kind": "ScalarField",
      "name": "issueCount"
    },
    {
      "kind": "LinkedField",
      "name": "fieldValue",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "priorityGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "assigneeGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "statusGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "categoryGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "sprintGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "storyPointsGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "goalGroupHeader_issueTableGrouping"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroup"
};

(node as any).hash = "6a54532f74844fb078861cda06291c92";

export default node;
